export default __webpack_public_path__ + "locales/pt/Files.json?hash=76d360fc541f5eb412b3205d6ec3ef0a";